import styled from 'styled-components'
import { Link } from '../application/router/Link'

export const RouterLink = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.link.dark};
  cursor: pointer;
`
